/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backstage_Point_2Inputs */

const en_backstage_point_2 = /** @type {(inputs: Backstage_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvals inside the work, with who and when`)
};

/**
* | output |
* | --- |
* | "Approvals inside the work, with who and when" |
*
* @param {Backstage_Point_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const backstage_point_2 = /** @type {((inputs?: Backstage_Point_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backstage_Point_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_backstage_point_2(inputs)
});